<template>
  <div :class="['mb-6', { 'has-errors': errors.length }]">
    <slot name="label">
      <label
        v-if="label"
        class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        :for="id">
        {{ label }}
        <span v-if="required" class="inline-block align-top text-red-400">
          *
        </span>
        <i v-if="tooltipText" v-tooltip="tooltipText" class="fa fa-circle-info ml-1 text-primary-300" />
      </label>
    </slot>

    <slot />

    <!-- eslint-disable-next-line vue/no-v-html -->
    <small v-if="hint" class="py-1 block text-gray-900 dark:text-white" v-html="hintParsed" />
    <small v-if="errors.length" class="errors-text">
      {{ errors.join(', ') }}
    </small>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import vTooltip from '~/javascript/directives/tooltip'

const props = defineProps({
  label: { type: String, default: '' },
  id: { type: String, required: true },
  hint: { type: String, default: '' },
  required: { type: Boolean, deafult: false },
  tooltipText: { type: String, default: '' },
  errors: {
    type: Array,
    default() {
      return []
    }
  }
})

// const hintParsed = computed(() => {
//   const linkPattern = /(?<!href=["'])\bhttps?:\/\/[^\s<>"]+/g
//   return props.hint.replace(linkPattern, '<a href="$&" class="text-primary-600" target="_blank">$&</a>')
// })

const hintParsed = computed(() => {
  const linkPattern = /(?<!href=["'])(\bhttps?:\/\/[^\s<>"]+?)([.,!?;:]+)?(?=\s|$)/g

  return props.hint.replace(linkPattern, (match, url, punctuation) => {
    const replaceText = `<a href="${url}" class="text-primary-600" target="_blank">${url}</a>${punctuation || ''}`
    return replaceText
  })
})
</script>
